// Stringify an JS object
export const objToString = (obj = {}) => JSON.stringify(obj, null, 2);
